/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import useTitle from 'utils/customHook/useTitle'
import { PATH_PGSSE } from 'home/constants/RouteConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getDeleteOption, getUdiSectorName } from 'pgsse/util/PgsseUtil'
import InstallationAction from 'installation/actions/InstallationAction'
import Form from './form/Form'
import PgsseAction from 'pgsse/action/PgsseAction'
import { useParams } from 'react-router'
import { getLabel } from 'utils/StoreUtils'
import { isNil } from 'lodash'
import useActions from 'utils/customHook/useActions'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'
import moment from 'moment'
import { Box } from '@mui/material'
import PGSSEExport from '../common/PGSSEExport'
import { push } from '@lagunovsky/redux-react-router'
import { PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_FORM_DELETE } from 'aquaparc/AquaparcConstants'
import { sendStat } from 'aquaparc/AquaparcStatsSender'

const PgsseCampaignFormApp = ({
}) => {
    const dispatch = useDispatch()
    const { idCampaign, idDiagnostic, idForm } = useParams()

    const [isFormLoaded, setIsFormLoaded] = useState(false)
    const [isSurveyLoaded, setIsSurveyLoaded] = useState(false)
    const [readMode, setReadMode] = useState(true)
    const [isOpen, setIsOpen] = useState(false)
    const [form, setForm] = useState({})

    const {
        campaign,
        distributionUnits,
        sectors,
        diagnostic,
        form: propsForm,
        installation,
        installations,
        survey,
        accountUser,
    } = useSelector(store => ({
        campaign: store.PgsseReducer.campaign,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        diagnostic: store.PgsseReducer.diagnostic,
        form: store.PgsseReducer.form,
        installation: store.InstallationReducer.installation,
        installations: store.InstallationReducer.installationsLight,
        survey: store.PgsseReducer.survey,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    useEffect(() => {
        setForm(propsForm)
    }, [propsForm])

    useEffect(() => {
        setIsFormLoaded(false)
        dispatch(PgsseAction.fetchForm(idForm)).then(() => setIsFormLoaded(true))
    }, [dispatch, idForm])

    useEffect(() => {
        dispatch(PgsseAction.fetchDiagnostic(idDiagnostic))
        dispatch(PgsseAction.fetchCampaign(idCampaign))
    }, [idCampaign, idDiagnostic])

    useEffect(() => {
        if (!isNil(form.idSurvey) && !isNil(installation.installationType)) {
            setIsSurveyLoaded(false)
            dispatch(PgsseAction.fetchSurvey(form.idSurvey, {
                stationType: form.stationType,
                installationType: installation.installationType,
            })).then(() => setIsSurveyLoaded(true))
        }
    }, [dispatch, propsForm, installation])

    useEffect(() => {
        if (isNil(form.code)) return
        dispatch(InstallationAction.fetchInstallation(form.code))
    }, [dispatch, form.code])

    const onSave = ({ finaliseForm = false }) => {
        if (form.formStatus === 1 && form.stationType === STATION_TYPE_CONSTANT.INSTALLATION) {
            dispatch(InstallationAction.addInstallationEvent(
                form.code,
                {
                    code: installation.id,
                    eventDate: moment().valueOf(),
                    eventType: '',
                    comment: i18n.formEvent,
                    campaignCode: parseInt(idCampaign),
                    campaignType: 1,
                }))
        }
        dispatch(PgsseAction.updateForm(form.idForm, {
            ...form,
            formStatus: finaliseForm || form.formStatus === 3 ? 3 : 2,
        })).then(() => {
            setReadMode(true)
        })
    }

    useTitle(() => {
        const udi = distributionUnits.find(du => du.id === diagnostic.idUdi)
        const sector = sectors.find(s => s.id === diagnostic.idSector)
        return [{
            title: i18n.pgsse,
            href: PATH_PGSSE,
        }, {
            title: i18n.phase1,
            href: `${PATH_PGSSE}/phase1`,
        }, {
            title: getUdiSectorName(udi, sector),
            href: `${PATH_PGSSE}/phase1/${diagnostic.idDiag}`,
        }, {
            title: campaign.name,
            href: `${PATH_PGSSE}/phase1/${diagnostic.idDiag}/campaign/${campaign.idCampaign}`,
        }, {
            title: getLabel(installations, form.code),
            href: `${PATH_PGSSE}/phase1/${diagnostic.idDiag}/campaign/${campaign.idCampaign}/${idForm}`,
        }]
    }, [diagnostic, installation, distributionUnits, sectors, campaign, installations, form])

    const onDelete = () => {
        sendStat(PGSSE_PHASE1_DIAGNOSTIC_CAMPAGNES_FORM_DELETE)
        dispatch(PgsseAction.deleteForm(idForm)).then(() => {
            dispatch(push(`${PATH_PGSSE}/phase1/${diagnostic.idDiag}/campaign/${campaign.idCampaign}`))
        })
    }

    useActions(() => {
        return readMode ? {
            edit: () => setReadMode(false),
            exportList: [{
                onClick: () => setIsOpen(true),
                label: i18n.excel,
            }],
            ...getDeleteOption(accountUser, onDelete),
        } : {
            save: () => onSave({ finaliseForm: false }),
            cancel: () => {
                setForm(propsForm)
                setReadMode(true)
            },
        }
    }, [readMode, form, propsForm, accountUser])

    return (
        <Box sx={{ padding: '10 10 10 20' }}>
            <Form
                title={getLabel(installations, form.code)}
                form={form}
                setForm={setForm}
                survey={survey}
                isFormLoaded={isFormLoaded}
                isSurveyLoaded={isSurveyLoaded}
                readMode={readMode}
                onSave={onSave}
            />
            <PGSSEExport
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                form={form}
                survey={survey}
                name={installation.name}
            />
        </Box>
    )
}

PgsseCampaignFormApp.propTypes = {
}

export default PgsseCampaignFormApp
